//# sourceMappingURL=my-date.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/mydatepicker/dist/interfaces/my-date.interface.js
// module id = 350
// module chunks = 3